module.exports = __webpack_public_path__ + "static/media/9.67d348ed.jpg";